const refundType = {
  FRAUD: 'FRAUD',
  OPERATIONAL_FLAW: 'OPERATIONAL_FLAW',
  REFUND_CANCELLED: 'REFUND_CANCELLED'
};

module.exports = refundType;
